
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as accountMAmYwsQu0NMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/account.vue?macro=true";
import { default as complete_45accountJLeUTnp33zMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/complete-account.vue?macro=true";
import { default as forgot_45passwordj2hSAk7crzMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/forgot-password.vue?macro=true";
import { default as homeweWuofRgP9Meta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/home.vue?macro=true";
import { default as index7FpSsVQbtXMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/index.vue?macro=true";
import { default as loginrERS8HbhjWMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/login.vue?macro=true";
import { default as notificationszvUUtQ8DTCMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/notifications.vue?macro=true";
import { default as reset_45passwordxkkSi1qCd6Meta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/reset-password.vue?macro=true";
import { default as client_45filtersMwqqUOk1DUMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-filters.vue?macro=true";
import { default as client_45groupsrzv8MVLjoUMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-groups.vue?macro=true";
import { default as _91id_93KmPCqtPd3AMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/delivery-sheet/[id].vue?macro=true";
import { default as indexenlLaYgyE9Meta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/index.vue?macro=true";
import { default as _91id_93yYSNXTk8l5Meta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/view/[id].vue?macro=true";
import { default as clientsYJOdxV5DskMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients.vue?macro=true";
import { default as delivery_45sheetsmb4SzJI3M1Meta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/delivery-sheets.vue?macro=true";
import { default as indexeJZle2tAMlMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/index.vue?macro=true";
import { default as newqy9T4SGCX8Meta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/new.vue?macro=true";
import { default as exportmBQO1BETCUMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export.vue?macro=true";
import { default as indexP8N3i58pJEMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/index.vue?macro=true";
import { default as newyJsGuFEmWsMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/new.vue?macro=true";
import { default as _91id_93bg71gxl2HgMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/view/[id].vue?macro=true";
import { default as importCRRRmeEBXnMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import.vue?macro=true";
import { default as indexzydRgkGnsFMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/index.vue?macro=true";
import { default as createRx4MgJINvYMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/create.vue?macro=true";
import { default as _91id_93va3L9Sgv6zMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/dashboard/[id].vue?macro=true";
import { default as _91id_936e89q51MYqMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/edit/[id].vue?macro=true";
import { default as indexOe7Jly7jJBMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/index.vue?macro=true";
import { default as inventoriesBypINkRkqKMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories.vue?macro=true";
import { default as inventory8p2lvJiVE1Meta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory.vue?macro=true";
import { default as indexFPCUtwz6xLMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/knowledge-base/index.vue?macro=true";
import { default as activityLaOxssCeZyMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/activity.vue?macro=true";
import { default as burndownmf6ihkBpA9Meta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/burndown.vue?macro=true";
import { default as indexI19j9PQ6UgMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/index.vue?macro=true";
import { default as reportingeg0yZ7SkRDMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting.vue?macro=true";
import { default as _91id_93JX9Ens7A3kMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/[id].vue?macro=true";
import { default as indexxPzxh19IYNMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/index.vue?macro=true";
import { default as appointmentsYyj0pYqSlIMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments.vue?macro=true";
import { default as index8Mb6Jd9acvMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/index.vue?macro=true";
import { default as _91id_93oID9PM2nLdMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/inventory/[id].vue?macro=true";
import { default as client_45assignmentNqTpnBxXZXMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment.vue?macro=true";
import { default as client_45dashboardqSt7tQGkMpMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-dashboard.vue?macro=true";
import { default as index82R676z5vjMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/index.vue?macro=true";
import { default as _91id_93IjyMESzqRZMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/profile/[id].vue?macro=true";
import { default as collaboratorsRAYRyXrpqdMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators.vue?macro=true";
import { default as indexmPGjR0fYkIMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/index.vue?macro=true";
import { default as roadmapr5ihWOsXcgMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/roadmap.vue?macro=true";
import { default as indexCImYVEOCZKMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks/index.vue?macro=true";
import { default as tasksTXOoZ1yOWzMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks.vue?macro=true";
import { default as rolloutiXdG0CG1eTMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout.vue?macro=true";
import { default as schedule_45appointmentp2CGoxUYsYMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/schedule-appointment.vue?macro=true";
import { default as branding2R3M2Fab6VMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/settings/branding.vue?macro=true";
import { default as createqSVk1qLvlXMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/settings/checklists/create.vue?macro=true";
import { default as _91id_93vSvL5QgnqUMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/settings/checklists/edit/[id].vue?macro=true";
import { default as index4UEj4foKA6Meta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/settings/checklists/index.vue?macro=true";
import { default as checklistsao6EXbd3ZbMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/settings/checklists.vue?macro=true";
import { default as client_45linksDwXq9Vft24Meta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/settings/client-links.vue?macro=true";
import { default as custom_45fieldsiLNpY7Siz9Meta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/settings/custom-fields.vue?macro=true";
import { default as indexlyeLZFPad3Meta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/settings/index.vue?macro=true";
import { default as integrations8qGVSQLlmNMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/settings/integrations.vue?macro=true";
import { default as rolloutsCN1aslZF1rMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/settings/rollouts.vue?macro=true";
import { default as subscriptiongU4U9Xkas8Meta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/settings/subscription.vue?macro=true";
import { default as usersY3bgoQyKprMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/settings/users.vue?macro=true";
import { default as createyAz87ET6nMMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/settings/workflows/create.vue?macro=true";
import { default as _91id_93lk1oneqn6hMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/settings/workflows/edit/[id].vue?macro=true";
import { default as index5csspvNl9wMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/settings/workflows/index.vue?macro=true";
import { default as workflowsSetEyeonNUMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/settings/workflows.vue?macro=true";
import { default as settingsO0wlrCgEdxMeta } from "/codebuild/output/src3264125088/src/packages/frontend/pages/settings.vue?macro=true";
export default [
  {
    name: "account",
    path: "/account",
    meta: accountMAmYwsQu0NMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/account.vue")
  },
  {
    name: "complete-account",
    path: "/complete-account",
    meta: complete_45accountJLeUTnp33zMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/complete-account.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordj2hSAk7crzMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/forgot-password.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: homeweWuofRgP9Meta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/home.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index7FpSsVQbtXMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginrERS8HbhjWMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/login.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationszvUUtQ8DTCMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/notifications.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordxkkSi1qCd6Meta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/reset-password.vue")
  },
  {
    name: inventory8p2lvJiVE1Meta?.name,
    path: "/rollout-project/:rolloutIdentifier()/inventory",
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-client-filters",
    path: "client-filters",
    meta: client_45filtersMwqqUOk1DUMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-filters.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-client-groups",
    path: "client-groups",
    meta: client_45groupsrzv8MVLjoUMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-groups.vue")
  },
  {
    name: clientsYJOdxV5DskMeta?.name,
    path: "clients",
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients-delivery-sheet-id",
    path: "delivery-sheet/:id()",
    meta: _91id_93KmPCqtPd3AMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/delivery-sheet/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients",
    path: "",
    meta: indexenlLaYgyE9Meta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients-view-id",
    path: "view/:id()",
    meta: _91id_93yYSNXTk8l5Meta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/view/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-delivery-sheets",
    path: "delivery-sheets",
    meta: delivery_45sheetsmb4SzJI3M1Meta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/delivery-sheets.vue")
  },
  {
    name: exportmBQO1BETCUMeta?.name,
    path: "export",
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-export",
    path: "",
    meta: indexeJZle2tAMlMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-export-new",
    path: "new",
    meta: newqy9T4SGCX8Meta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/new.vue")
  }
]
  },
  {
    name: importCRRRmeEBXnMeta?.name,
    path: "import",
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-import",
    path: "",
    meta: indexP8N3i58pJEMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-import-new",
    path: "new",
    meta: newyJsGuFEmWsMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/new.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-import-view-id",
    path: "view/:id()",
    meta: _91id_93bg71gxl2HgMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/view/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory",
    path: "",
    meta: indexzydRgkGnsFMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/index.vue")
  },
  {
    name: inventoriesBypINkRkqKMeta?.name,
    path: "inventories",
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-create",
    path: "create",
    meta: createRx4MgJINvYMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/create.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-dashboard-id",
    path: "dashboard/:id()",
    meta: _91id_93va3L9Sgv6zMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/dashboard/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-edit-id",
    path: "edit/:id()",
    meta: _91id_936e89q51MYqMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/edit/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories",
    path: "",
    meta: indexOe7Jly7jJBMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/index.vue")
  }
]
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-knowledge-base",
    path: "/rollout-project/:rolloutIdentifier()/knowledge-base",
    meta: indexFPCUtwz6xLMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/knowledge-base/index.vue")
  },
  {
    name: reportingeg0yZ7SkRDMeta?.name,
    path: "/rollout-project/:rolloutIdentifier()/reporting",
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-reporting-activity",
    path: "activity",
    meta: activityLaOxssCeZyMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/activity.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-reporting-burndown",
    path: "burndown",
    meta: burndownmf6ihkBpA9Meta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/burndown.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-reporting",
    path: "",
    meta: indexI19j9PQ6UgMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/index.vue")
  }
]
  },
  {
    name: rolloutiXdG0CG1eTMeta?.name,
    path: "/rollout-project/:rolloutIdentifier()/rollout",
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout.vue"),
    children: [
  {
    name: appointmentsYyj0pYqSlIMeta?.name,
    path: "appointments",
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-appointments-id",
    path: ":id()",
    meta: _91id_93JX9Ens7A3kMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-appointments",
    path: "",
    meta: indexxPzxh19IYNMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/index.vue")
  }
]
  },
  {
    name: client_45assignmentNqTpnBxXZXMeta?.name,
    path: "client-assignment",
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-assignment",
    path: "",
    meta: index8Mb6Jd9acvMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-assignment-inventory-id",
    path: "inventory/:id()",
    meta: _91id_93oID9PM2nLdMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/inventory/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-dashboard",
    path: "client-dashboard",
    meta: client_45dashboardqSt7tQGkMpMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-dashboard.vue")
  },
  {
    name: collaboratorsRAYRyXrpqdMeta?.name,
    path: "collaborators",
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-collaborators",
    path: "",
    meta: index82R676z5vjMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-collaborators-profile-id",
    path: "profile/:id()",
    meta: _91id_93IjyMESzqRZMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/profile/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout",
    path: "",
    meta: indexmPGjR0fYkIMeta || {},
    alias: ["/rollout-project/:rolloutIdentifier()"],
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-roadmap",
    path: "roadmap",
    meta: roadmapr5ihWOsXcgMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/roadmap.vue")
  },
  {
    name: tasksTXOoZ1yOWzMeta?.name,
    path: "tasks",
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-tasks",
    path: "",
    meta: indexCImYVEOCZKMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks/index.vue")
  }
]
  }
]
  },
  {
    name: "schedule-appointment",
    path: "/schedule-appointment",
    meta: schedule_45appointmentp2CGoxUYsYMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/schedule-appointment.vue")
  },
  {
    name: settingsO0wlrCgEdxMeta?.name,
    path: "/settings",
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/settings.vue"),
    children: [
  {
    name: "settings-branding",
    path: "branding",
    meta: branding2R3M2Fab6VMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/settings/branding.vue")
  },
  {
    name: checklistsao6EXbd3ZbMeta?.name,
    path: "checklists",
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/settings/checklists.vue"),
    children: [
  {
    name: "settings-checklists-create",
    path: "create",
    meta: createqSVk1qLvlXMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/settings/checklists/create.vue")
  },
  {
    name: "settings-checklists-edit-id",
    path: "edit/:id()",
    meta: _91id_93vSvL5QgnqUMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/settings/checklists/edit/[id].vue")
  },
  {
    name: "settings-checklists",
    path: "",
    meta: index4UEj4foKA6Meta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/settings/checklists/index.vue")
  }
]
  },
  {
    name: "settings-client-links",
    path: "client-links",
    meta: client_45linksDwXq9Vft24Meta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/settings/client-links.vue")
  },
  {
    name: "settings-custom-fields",
    path: "custom-fields",
    meta: custom_45fieldsiLNpY7Siz9Meta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/settings/custom-fields.vue")
  },
  {
    name: "settings",
    path: "",
    meta: indexlyeLZFPad3Meta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/settings/index.vue")
  },
  {
    name: "settings-integrations",
    path: "integrations",
    meta: integrations8qGVSQLlmNMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/settings/integrations.vue")
  },
  {
    name: "settings-rollouts",
    path: "rollouts",
    meta: rolloutsCN1aslZF1rMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/settings/rollouts.vue")
  },
  {
    name: "settings-subscription",
    path: "subscription",
    meta: subscriptiongU4U9Xkas8Meta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/settings/subscription.vue")
  },
  {
    name: "settings-users",
    path: "users",
    meta: usersY3bgoQyKprMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/settings/users.vue")
  },
  {
    name: workflowsSetEyeonNUMeta?.name,
    path: "workflows",
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/settings/workflows.vue"),
    children: [
  {
    name: "settings-workflows-create",
    path: "create",
    meta: createyAz87ET6nMMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/settings/workflows/create.vue")
  },
  {
    name: "settings-workflows-edit-id",
    path: "edit/:id()",
    meta: _91id_93lk1oneqn6hMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/settings/workflows/edit/[id].vue")
  },
  {
    name: "settings-workflows",
    path: "",
    meta: index5csspvNl9wMeta || {},
    component: () => import("/codebuild/output/src3264125088/src/packages/frontend/pages/settings/workflows/index.vue")
  }
]
  }
]
  }
]